import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'auth/auth';
import { api as loanServiceAPI } from 'constants/constant';

export const consumerToolsAPI = createApi({
  reducerPath: 'consumerToolsAPI',
  tagTypes: ['consumerTools'],
  baseQuery: fetchBaseQuery({ baseUrl: loanServiceAPI, credentials: 'include' }),
  endpoints: (builder) => ({
    getConsumerToolApplications: builder.query({
      query: () => ({
        url: `b2c/loan/tools/applications`,
        method: 'GET',
        headers: getHeaders(),
      }),
      keepUnusedDataFor: 300,
    }),
    getAmortizationScheduleConsumer: builder.query({
      query: ({ applicationId }) => ({
        url: `b2c/loan/tools/get_amortization_schedule_consumer/application/${applicationId}`,
        method: 'GET',
        headers: getHeaders(),
      }),
      keepUnusedDataFor: 300,
    }),
    getCurrentOfferConsumer: builder.query({
      query: ({ applicationId }) => ({
        url: `b2c/loan/tools/get_current_offer_consumer/application/${applicationId}`,
        method: 'GET',
        headers: getHeaders(),
      }),
      keepUnusedDataFor: 300,
    }),
    compareUserInputConsumer: builder.mutation({
      query: ({ data }) => ({
        url: `b2c/loan/tools/compare_offer_by_user_input_consumer`,
        method: 'POST',
        body: data,
        headers: getHeaders(),
      }),
    }),
    consumerOfferDocument: builder.mutation({
      query: ({ data }) => {
        const headers = getHeaders();
        delete headers['Content-Type'];
        delete headers['content-type'];
        return {
          url: `b2c/loan/tools/compare_offer_document_upload_consumer`,
          body: data,
          headers,
          method: 'POST',
        };
      },
    }),
  }),
});

export const {
  useGetConsumerToolApplicationsQuery,
  useGetAmortizationScheduleConsumerQuery,
  useGetCurrentOfferConsumerQuery,
  useCompareUserInputConsumerMutation,
  useConsumerOfferDocumentMutation,
} = consumerToolsAPI;
